/**
 * The weight a parcel was actually billed on, from the fields a pack card
 * already holds — so a list of cards can decide whether to offer the price
 * breakdown without a request per card.
 *
 * cal_price_by mirrors the server: 1 = real weight, 2 = volumetric. Before the
 * warehouse decides, neither is authoritative, so we take the larger — the same
 * side the calculator errs on.
 */
export const billedWeight = (pack) => {
   const real = Number(pack?.total_weight || 0);
   const volume = Number(pack?.volume_weight || 0);
   if (Number(pack?.cal_price_by) === 2) return volume;
   if (Number(pack?.cal_price_by) === 1) return real;
   return Math.max(real, volume);
};

/**
 * Above this billed weight the price is worth explaining unprompted — it is
 * where the tier, the volumetric rule and the flight's combined weight start
 * to matter, and where the support questions come from.
 *
 * Mirrors PriceExplanation::INFO_THRESHOLD_KG.
 */
export const PRICE_INFO_THRESHOLD_KG = 10;

export const priceNeedsExplaining = (pack) =>
   billedWeight(pack) > PRICE_INFO_THRESHOLD_KG;
